import type { MarketRecap } from "../types";
import { sleep } from "../utils/format";

export const mockApi = {
  async analyzeQuery(query: string): Promise<{ answer: string; followups: string[] }> {
    await sleep(380);
    const q = query.trim();
    if (!q) {
      return {
        answer: "请输入你想分析的新闻、公司或宏观主题。",
        followups: [
          "NVDA 本周驱动因素？",
          "美债收益率对科技股的影响？",
          "如何解读能源板块轮动？",
        ],
      };
    }
    return {
      answer: `已收到：${q}。\n\n（Mock）系统会基于所选新闻源与资产池，输出：1) 事件摘要；2) 影响路径（行业/主题/因子）；3) 多空要点；4) 风险项与观察指标。`,
      followups: ["给出多空分歧点", "补充相关标的", "生成一段可复用的研究摘要"],
    };
  },

  async getMarketRecap(): Promise<{ recap: MarketRecap }> {
    await sleep(220);
    return {
      recap: {
        sector: [
          { label: "Healthcare", changePct: 1.96 },
          { label: "Energy", changePct: -2.81 },
        ],
        theme: [
          { label: "Memory Chips", changePct: 27.6 },
          { label: "AI Chips", changePct: -0.5 },
        ],
        narrative:
          "The U.S. stock market closed higher today as major indexes advanced with broad participation and strong sector dynamics supporting the rally. Healthcare stocks emerged as the best-performing sector, driven by gains in biotech and pharmaceutical names, while the Energy sector lagged on weaker commodity sentiment and profit-taking after recent strength. Thematic drivers showed strength in data storage and memory chip stocks, boosted by positive AI and cloud demand outlooks, while shares of AI hardware names saw slight weakness due to profit taking and mixed short-term sentiment. Market breadth improved as more stocks rose than fell on both the NYSE and Nasdaq, reflecting continued investor risk appetite, although macroeconomic indicators and monetary policy expectations remain key near-term influences. Looking ahead, investors remain focused on upcoming earnings reports, economic data, and central bank signals, with sector rotation into defensive and growth themes suggesting selective leadership even as cyclical pressures persist.",
      },
    };
  },
};
